import { render, staticRenderFns } from "./MerchandisingProductIdentification.vue?vue&type=template&id=2cbf4dfb"
import script from "./MerchandisingProductIdentification.vue?vue&type=script&lang=js"
export * from "./MerchandisingProductIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports